/**
 * Error thrown by the ts-rest hooks for a non-2xx response, carrying the
 * backend message when the body has one and the HTTP status for callers
 * that branch on it (e.g. `use404Redirect`).
 */
export class HttpError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
    this.name = 'HttpError';
  }
}
